module.exports = __webpack_public_path__ + "static/media/tint.4257665f.svg";